import { get } from 'pc-sales/utils/http';
type platform = 'mt4' | 'mt5';

export interface EssentialAccTypeItem {
    // 同名基础账户类型在多台服务器上的 id 集合（后端按 name 去重后合并）
    ids: number[];
    name: string;
}

export class BasicAccountTypeApi {
    // 获取基础账户类型
    get = (data: {
        page?: number;
        pagesize?: number;
        platform?: 'mt4' | 'mt5';
        server_id?: string;
        name?: string;
        fields?: string;
    }) => get('/v2/server/basicAccountType', data);

    /**
     * 基础账户类型下拉数据源：按名称跨服务器去重，返回项为 { ids, name }。
     * ids 是同名类型在各服务器上的 id 集合，用于筛选时回传 ids.join(',')。
     */
    getEssentialAccList = (data?: {
        page?: number;
        pagesize?: number;
        platform?: 'mt4' | 'mt5';
        server_id?: string;
        name?: string;
        fields?: string;
    }): Promise<{ data: EssentialAccTypeItem[] }> => get('/v2/server/basicAccountType/getEssentialAccList', data);

    // 获取子账号列表
    getSub = (data: { essential_acc_id?: number; platform?: platform; server_id?: string; name?: string }) =>
        get('/v2/server/basicAccountType/getSub', data);
}

export default new BasicAccountTypeApi();
